import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { fetchLoginPageConfig } from "services/strapi.service";
import { resolveLanguage } from "services/language.service";
import { useLocation } from "react-router-dom";
import { LoginPageConfig } from "types";
import { defaultConfigId } from "env";

export function useStrapiConfig(): UseQueryResult<LoginPageConfig | null> {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const config_id = query.get("config_id") ?? defaultConfigId;

  return useQuery({
    queryKey: ["login-page-config", config_id],
    // TEMPORARY: proves resolveLanguage() (and its Applicaster storage reads)
    // fully complete before the Strapi fetch fires. Remove once confirmed.
    queryFn: async () => {
      const language = await resolveLanguage();
      console.log(`[useStrapiConfig] resolveLanguage() done, now calling Strapi with language="${language}"`);
      return fetchLoginPageConfig(config_id, language);
    },
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: 1,
  });
}
